import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { BarChart3 } from 'lucide-react';
import type { ManagementReportingColumnsTabProps } from './types';

const COLUMN_KEYS = [
  'column1', 'column2', 'column3', 'column4', 'column5',
  'column6', 'column7', 'column8', 'column9', 'column10',
] as const;

export function ManagementReportingColumnsTab({
  options,
  onOptionsChange,
  setHasUnsavedChanges,
}: Readonly<ManagementReportingColumnsTabProps>): React.ReactElement {
  return (
    <div className="space-y-6">
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-primary" />
            Management Reporting Columns
          </CardTitle>
          <CardDescription>
            Define up to 10 column labels for statutory report groupings. Categories assigned to a column will be grouped together in the Statutory Report.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-4 md:grid-cols-2">
            {COLUMN_KEYS.map((key, index) => (
              <div key={key} className="space-y-2">
                <Label htmlFor={key}>Column {index + 1}</Label>
                <Input
                  id={key}
                  value={options.managementReportingLabels?.[key] ?? ''}
                  onChange={(e) => {
                    onOptionsChange(prev => ({
                      ...prev,
                      managementReportingLabels: {
                        ...prev.managementReportingLabels,
                        [key]: e.target.value,
                      },
                    }));
                    setHasUnsavedChanges(true);
                  }}
                  placeholder={`Enter label for Column ${index + 1}`}
                />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
